import {
	mapState,
	mapActions,
	mapGetters
} from 'vuex';

import {
	tab,
	tabs,
	tabGroup
} from 'vue-strap';

import {
	DatePicker
} from 'element-ui';

// import $ from 'jquery';
import moment from 'moment';

import {
	EventBus
} from '@/support/event-bus';

import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

import PageBar from '@/components/page-bar/page-bar';

import SchoolClassList from '@/domains/school/class-list/main';
import ClassName from '@/domains/school/class-name/main';

import CreateHomeworkTheme from '@/domains/homework/themes/themes';
import CreateHomeworkButton from '@/domains/homework/create/create';

import Students from '@/domains/student/students';

import AgendaViewers from '@/domains/agenda/agenda-viewers/agenda-viewers';
import AgendaEditors from '@/domains/agenda/agenda-editors/agenda-editors';

import StudentName from '@/domains/student/name/name';
import StudentPresence from '@/domains/agenda/presence/StudentPresence.vue';
import StudentHumor from '@/domains/agenda/humor/humor';

import Alimentation from '@/domains/agenda/alimentation/alimentation.vue';
import Activities from '@/domains/agenda/activities/activities.vue';
import Highlight from '@/domains/agenda/highlight/main';
import Health from '@/domains/agenda/health/health.vue';
import Questions from '@/domains/agenda/questions/questions.vue';
import Others from '@/domains/agenda/others/main';

export default {
	state,
	actions,
	mutations,
	getters,
	name: 'agenda',
	components: {
		PageBar,
		ClassName,
		CreateHomeworkButton,
		CreateHomeworkTheme,
		Students,
		StudentName,
		StudentPresence,
		StudentHumor,
		AgendaViewers,
		AgendaEditors,
		SchoolClassList,
		tab,
		tabs,
		tabGroup,
		DatePicker,
		Alimentation,
		Activities,
		Health,
		Highlight,
		Questions,
		Others
	},
	data: () => ({
		homeworkVisible: false,
		datepicker: {
			today: new Date(),
			selected: new Date()
		},
		activeTabs: 0
	}),
	computed: {
		...mapState({
			agenda: (state) => state.Agenda,
			classes: (state) => state.Class,
			classLevel: (state) => state.Class.selected.schoolClassLevel,
			presence: (state) => state.Agenda.agenda.presence
		}),
		...mapGetters({
			klass: 'getClass',
			user: 'getLoggedUser',
			student: 'getStudent'
		})
	},
	methods: {
		...mapActions([
			'getAgenda',
			'saveAgenda',
			'setBreadcrumb',
			'putAgendaDate',
			'getStudents',
			'getMessages',
			'publishAgenda',
			'publishAllAgendas',
			'setStudent',
			'getAgendaStatus',
			'setSelectedClass'
		]),
		getStatus() {

			this.getAgendaStatus({
				userId: this.user.id,
				schoolClassId: this.klass.schoolClassId,
				date: moment(this.agenda.date).format('YYYY-MM-DD')
			});

		},
		setAgendaDate(currentDate) {

			if (currentDate) {

				let [date, month, year] = currentDate.split('/');

				currentDate = moment().set({
					year,
					month: (month - 1),
					date,
					hour: 0,
					minute: 0,
					second: 0
				});

				this.putAgendaDate(moment(currentDate).format('YYYY-MM-DD'));

				if (this.student && this.student.studentId) {

					this.getAgenda({
						userId: this.user.id,
						studentId: this.student.studentId,
						date: moment(this.agenda.date).format('YYYY-MM-DD')
					}).then(() => {
						EventBus.$emit('setAgenda');
					});

				}

				if (this.klass && this.klass.schoolClassId) {
					this.getStatus();
				}

			}
		},
		resetStudent() {

			this.setStudent({});
			this.getStudents();

		},
		save() {

			this.saveAgenda().then(() => {
				this.getStatus();
			});

		},
		publish() {

			this.publishAgenda().then(() => {

				this.resetStudent();
				this.getStatus();

			});

		},
		publishAll() {

			this.publishAllAgendas().then(() => {

				this.resetStudent();
				this.getStatus();

			});

		}
	},
	created() {

		this.setSelectedClass({});

		this.setBreadcrumb([{
			text: 'Dia a dia'
		}, {
			text: 'Preparar Agenda'
		}]);

	},
	mounted() {

		EventBus.$on('toggleHomework', () => {
			this.homeworkVisible = !this.homeworkVisible;
		});

		EventBus.$on('setStudent', () => {
			this.activeTabs = 0;
		});

	},
	beforeDestroy() {

		EventBus.$off('toggleHomework');
		EventBus.$off('setStudent');

	}
};



// WEBPACK FOOTER //
// ./sources/app/agenda/index.js